import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex, Box } from 'reflexbox'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import injectSagas from 'helpers/injectSagas'
import _ from 'lodash'
import Dialog from './Dialog'
import UploadPage from './UploadPage'

import Input from 'components/fulcrum/input/Input'
import InputWrapper from 'components/custom/InputWrapper'

import { Checkbox } from 'react-toolbox/lib/checkbox'

import {
  MAX_SIZE,
  MODULE_NAME,
  FILE_TYPE_STRING
} from './constants'

import {
  activeSelector,
  pageSelector,
  newRevisionNameSelector,
  filesSelector,
  createNvbugSelector
} from './selectors'

import {
  setInactive,
  setUploadPage,
  dropRejected,
  postUploadFile,
  changeNewRevisionName,
  addUploadFiles,
  clearUploadFiles,
  clearNewRevisionName,
  toggleNvbugCheckbox
} from './actions'

import sagas from './sagas'

import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    active: activeSelector(state),
    page: pageSelector(state),
    newRevisionName: newRevisionNameSelector(state),
    files: filesSelector(state),
    createNvbug: createNvbugSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    disableDialog: () => {
      dispatch(setInactive())
      dispatch(clearUploadFiles())
      dispatch(clearNewRevisionName())
    },
    onDropRejected: (files) => dispatch(dropRejected(files)),
    onDropAccepted: (files) => dispatch(addUploadFiles(files)),
    onNewRevisionNameChange: (newName) => dispatch(changeNewRevisionName(newName)),
    onNvbugCheckboxClick: () => dispatch(toggleNvbugCheckbox()),
    onSubmit: (createNvbug) => dispatch(postUploadFile(createNvbug))
  }
}

class FulcrumUploadDialog extends Component {

  render (){
  const {
    active,
    page,
    disableDialog,
    onDropAccepted,
    onDropRejected,
    onNewRevisionNameChange,
    newRevisionName,
    files,
    onSubmit,
    createNvbug,
    onNvbugCheckboxClick
  } = this.props

  const actions = [
    { label: 'Cancel', onClick: disableDialog },
    { label: 'Submit', onClick: onSubmit.bind(this, createNvbug), disabled: !files || files === undefined || files.length == 0 },
  ]
  
  return (
    <Dialog
      active={active}
      onEscKeyDown={disableDialog}
      onOverlayClick={disableDialog}
      title='Submit NVQual Revision'
      actions={actions}
    >
      <InputWrapper label={"Revision Name"} >
        <Input
          placeholder={"Type Revision Name"}
          value={newRevisionName}
          onChange={onNewRevisionNameChange}
        />
      </InputWrapper>
      <UploadPage
        page={page}
        onDropAccepted={onDropAccepted}
        onDropRejected={onDropRejected}
        maxSize={MAX_SIZE}
        accept={FILE_TYPE_STRING.join(',')}
      />
      <InputWrapper label={"File Selected"} >
        <Input
          className={styles.fileInput}
          placeholder={"No File Selected"}
          value={_.get(files[0],'name','')}
          disabled
      />
      </InputWrapper>
      <InputWrapper label={'Create NVBugs Review'} >
        <Checkbox
            styleName='checkbox'
            key={'nvbug'}
            checked={createNvbug}
            onChange={onNvbugCheckboxClick.bind(this, createNvbug)}
          />
      </InputWrapper>
    </Dialog>
  )
  }
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({[MODULE_NAME]: sagas})

const enhance = compose(
  withSagas,
  withConnect,
  withStyle
)

export default enhance(FulcrumUploadDialog)
